import { Clipboard } from '@angular/cdk/clipboard';
import { Component, Input } from "@angular/core";
import { Store } from "@ngrx/store";
import { PartecipantInfo } from "src/app/models/WebServer/partecipantInfo";
import { PartecipantRoles } from "src/app/models/WebServer/partecipantRoles";
import { PartecipantStatus } from "src/app/models/WebServer/partecipantStatus";
import { CommandEvent } from 'src/app/models/commandEvent';
import { I18Service } from "src/app/services/i18.service";
import { NotificationService } from "src/app/services/notification.service";
import * as sessionActions from "src/app/store/actions/session.actions";
import * as sessionStatusActions from "src/app/store/actions/sessionStatus.actions";
import { AppState } from "src/app/store/states/app.state";
import { StatusCircleSize } from "../status-circle.component";

@Component({
    selector: 'app-session-info-content',
    templateUrl: './session-info-content.component.html',
    styleUrls: ['./session-info-content.component.scss']
  })
  export class SessionInfoContentComponent {
    @Input() AS!: AppState;
    @Input() expiresIn!: number;
    @Input() PARTECIPANTS!: PartecipantStatus[];

    StatusCircleSize = StatusCircleSize;
    PartecipantRoles = PartecipantRoles;

    constructor(
        public store: Store<AppState>,
        // public config: AppConfigService,
        private clipboard: Clipboard
      ) {  }

    copyLinksOnClipboard() {
        let str = '';
        this.AS.session.parameters.partecipantIds.forEach( (p, idx) => {
          if(p.active){
            const partInfo = this.AS.session.parameters.partecipantIds[idx];
            const partLink = this.AS.session.links[idx];
            const alias = (partInfo.partecipantRole != PartecipantRoles.OnSiteOperator)? '' : `&alias=${encodeURIComponent(partInfo.alias)}`
            const link = `${partLink.href}${alias}`;
            str = `${str}${I18Service.roleAndAlias(p)} => ${link}\n`;
          }
        })
    
        this.clipboard.copy(str);
        NotificationService.showSuccess(`${I18Service.get(`SNACKBAR.TEXTCOPIED`)}`);
    }
    copyLink(idx: number) {
      const partInfo = this.AS.session.parameters.partecipantIds[idx];
      const partLink = this.AS.session.links[idx];
      const alias = (partInfo.partecipantRole != PartecipantRoles.OnSiteOperator)? '' : `&alias=${encodeURIComponent(partInfo.alias)}`
      this.clipboard.copy(`${partLink.href}${alias}`);
      NotificationService.showSuccess(`${I18Service.get(`SNACKBAR.TEXTCOPIED`)}`);
    }
    removeGuest(guest: PartecipantInfo) {
      NotificationService.popupQuestion({msg:I18Service.get('LABELS.REMOVEGUESTTITLE', {alias: guest.alias})})
      .then((value) => {
        if (value.isConfirmed) {
          this.store.dispatch(sessionActions.removeGuest({guestId: guest.partecipantId}))
        }
      });
    }
    closeCurrentCall(p: PartecipantInfo) {
      NotificationService.popupQuestion({msg:I18Service.get('LABELS.CLOSECURRENTCALLTITLE', {part: I18Service.roleAndAlias(p)})})
      .then((value) => {
        if (value.isConfirmed) {
          this.store.dispatch(sessionStatusActions.cmd_dispatch({ cmd: CommandEvent.CloseCurrentCall, val:'', toIds: [p.partecipantId] }))
        }
      });

    }
  }